// removed by extract-text-webpack-plugin
module.exports = {"line":"_3-85JkQ8a9EcYGHRSDa0aB","title":"_385EtDF2iMsaAT6PU1LS0X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ValueLine/ValueLine.scss
// module id = 1344
// module chunks = 1